<template>
	<ul class="leftMenuWrap">
        <!-- <li>{{currentRouteKey}}</li> -->
        <li v-for="(list,index) in leftMenu" class="oneMenuGroup" :key="index"
            :class="{active:list.menu_request_url.search(currentRouteKey.split('/')[1])>-1}">
            <div class="firstMenuBox" @click="clickFirstMenu(list)"  >
                <div class="inner">
                    <div class="left">
                        <i :class="list.menu_icon" v-if="list.menu_icon"></i>
                        <i class="el-icon-s-order" v-else></i>
                    </div>
                    <div class="middle"><span class="menuName">{{list.menu_name}} </span></div>
                    <div class="right" v-if="list.subMenu&&list.subMenu.length>0">
                        <span v-if="list.isOpen" class="el-icon-arrow-up"></span>
                        <span v-if="!list.isOpen" class="el-icon-arrow-down"></span>
                    </div>
                </div>
            </div>
            <el-collapse-transition>
                <div  class="secondMenuBox" v-if="list.isOpen">
                    <div class="secondItem"
                        :class="{active:child.menu_request_url == currentRouteKey}"
                        v-for="(child,childIndex) in list.subMenu" @click="clickSecondMenu(child)"
                        :key="childIndex"
                    >
                        {{child.menu_name}} 
                    </div>
                </div>
            </el-collapse-transition>
            
        </li>

	</ul>
</template>

<script>
	import {		utils,json,log	} from '@/common/common.js'
    import {        api ,ajaxLogin, ajaxPost   } from '@/common/request.js'
    import NP from 'number-precision'

	export default {
		name: 'myLeft',
		data() {
			return {
                leftMenu:[],
                platAndMenuInfo:{},
			}
		},
		computed: {
		    currentRouteKey(){
		        let path=this.$route.meta.matchLeftKey
		        // console.log(this.$route,'当前路由-左菜单里面的显示')
		        return path
		    }
		},
		methods: {
            getLeftMenu(){
                let _this=this
                let arg={
                    "phone":utils.getPhone(),
                    "token":utils.getToken()
                }
                // this.platAndMenuInfo=JSON.parse(utils.getCookie('platAndMenuInfo_multiActive')) 
                // this.platAndMenuInfo=JSON.parse(utils.getCookie('platAndMenuInfo_multiActive')) 
                ajaxLogin('/admin/user/getSystemMenu', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.platAndMenuInfo=JSON.parse(res.data.menu) 
                        let allLists=_this.platAndMenuInfo.sysIdList
                        allLists.forEach(function(item,index){
                            if(item.sysId==utils.getSysId()){
                               let newArr=JSON.parse(JSON.stringify(item.userHasMenu)).map(function(mapItem,mapIndex){
                                   mapItem.isOpen=false
                                   return mapItem
                               })
                                _this.leftMenu=newArr
                                return false
                            }
                        })
                         
                         //获取当前用户的功能
                         let allFunction=JSON.parse(res.data.module).sysIdList
                         let sysFunction=[]
                         let currentFunction=[]
                          allFunction.forEach(function(item,index){
                              if(item.sysId==utils.getSysId()){
                                  sysFunction=item.userHasmodule
                              }
                          })
                          console.log(sysFunction,'sysFunction')
                          sysFunction.forEach(function(item,index){
                              currentFunction.push(item.module_key)
                              console.log(item,"item--------------")

                              if(item.subModule&&item.subModule.length>0){
                                  item.subModule.forEach(function(item2,index2){
                                      currentFunction.push(item2.module_key)
                                  })
                              }
                          })
                          console.log(currentFunction,"currentFunction")
                          sessionStorage.setItem("currentFunction_szhc",JSON.stringify(currentFunction) )
                    }
                }, function(res) {
                })
                
                
                
                 
                 // 下面是common.js里的菜单数据
                 
                // let newArr=json.leftMenu_fake.map(function(item,index){
                //      item.isOpen=''
                //      return item
                // })
                // this.leftMenu=newArr
                // console.log( this.leftMenu)
            },
            clickFirstMenu(list){
                utils.log(list)
                if(list.subMenu&&list.subMenu.length>0){
                    list.isOpen=!list.isOpen
                }else{
                    let url=list.menu_request_url
                    this.$router.push(url)
                    utils.clearSearchObjSession()
                    sessionStorage.setItem("ActiveModuleCurrentConferenceId",'')//活动列表保存的当前活动id
                }
                
                
            },
            clickSecondMenu(list){
                let url=list.menu_request_url
                this.$router.push(url)
                utils.clearSearchObjSession()
                sessionStorage.setItem("ActiveModuleCurrentConferenceId",'')

            },
            // 获取平台服务费率
            getPlatformFee() {
                ajaxPost("/config/getConfigKey", {
                    configName: 'global_service_charge'
                }).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        let rate = +res.data.config_value
                        this.$sysConfig.globalServiceCharge = rate
                        this.$sysConfig.globalServiceChargePercent = NP.times(100, rate) + '%'
                    }
                });
            }
		},
		mounted() { //每次刷新重新加载leftmenu
            this.getLeftMenu()  
            this.getPlatformFee()  
		}
	}
</script>

<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .leftMenuWrap{
        .oneMenuGroup.active  .firstMenuBox, .firstMenuBox:hover{
            .inner {
                background: #fff;
                color: #160969;
            }
        }

        .oneMenuGroup{
            color:#fff;
            .firstMenuBox{
                cursor:pointer; height: 48px;
                padding: 0; box-sizing: border-box;
                margin-top: 8px;
                .inner { display: flex; height: 36px; align-items: center;}
                .left {
                    width: 36px;text-align: center;
                    i {font-size: 20px;}
                }
                .middle{flex: 1; font-size: 14px;}
                .right{width: 25px;}
            }
           
            .secondMenuBox{
                .secondItem{
                    cursor:pointer; padding:16px 0; padding-left:44px; font-size: 12px;
                    font-weight: 500; line-height: 1;
                }
                .secondItem:hover{color: #3c9fdb;}
                .secondItem.active{color: #3c9fdb;font-weight: bold;}
               
            }
        }
        
    }
</style>



// WEBPACK FOOTER //
// src/components/leftComponent.vue